document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.complete-the-look').forEach(function (widget) {
    const track = widget.querySelector('.complete-the-look__list');
    const items = widget.querySelectorAll('.complete-the-look__item');
    const prevBtn = widget.querySelector('.complete-the-look__arrow--prev');
    const nextBtn = widget.querySelector('.complete-the-look__arrow--next');
    let currentIndex = 0;

    function updateSlide() {
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === items.length - 1;
    }

    if (items.length > 0) {
      updateSlide();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlide();
      }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < items.length - 1) {
        currentIndex++;
        updateSlide();
      }
    });

    widget.querySelectorAll('.complete-the-look__variant-select').forEach(function (select) {
      select.addEventListener('change', function () {
        const item = select.closest('.complete-the-look__item');
        const btn = item.querySelector('.complete-the-look__add-btn');
        btn.dataset.variantId = select.value;
      });
    });

    widget.querySelectorAll('.complete-the-look__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (err) {
                throw new Error(err.description || 'Could not add to cart');
              });
            }
            return response.json();
          })
          .then(function () {
            btn.textContent = 'Added!';
            btn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (typeof window.Shopify !== 'undefined' && document.querySelector('cart-drawer')) {
              document.querySelector('cart-drawer').dispatchEvent(new CustomEvent('cart:refresh'));
            }
            setTimeout(function () {
              btn.textContent = originalText;
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 1500);
          })
          .catch(function (error) {
            btn.textContent = 'Error';
            console.error(error);
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          });
      });
    });
  });
});